"use strict";

/* ============================================================
   Wedding cinema — scroll-driven film engine.
   - [data-scrub] pins: sticky stage; scroll progress drives
     video.currentTime (lerped) + timed [data-window] labels.
   - [data-autoplay] videos: loop while on screen, pause off.
   - [data-lit] copy blocks reveal on scroll.
   Synchronous scroll handler (works without rAF-dependent IO).
   ============================================================ */
(function () {
  var page = document.querySelector(".wed");
  if (!page) return;

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var scrubs = [].slice.call(page.querySelectorAll("[data-scrub]")).map(function (pin) {
    var video = pin.querySelector("video");
    var overlays = [].slice.call(pin.querySelectorAll("[data-window]")).map(function (el) {
      var w = el.getAttribute("data-window").split("-");
      return { el: el, from: parseFloat(w[0]), to: parseFloat(w[1]) };
    });
    return {
      pin: pin,
      video: video,
      autoplay: !!(video && video.hasAttribute("data-autoplay")),
      overlays: overlays,
      shade: pin.querySelector(".wed-shade"),
      heroCopy: pin.querySelector(".wed-hero-copy"),
      hint: pin.querySelector(".wed-scroll-hint"),
      target: 0, current: 0, duration: 0
    };
  });

  scrubs.forEach(function (s) {
    if (!s.video) return;
    s.video.muted = true;
    s.video.setAttribute("playsinline", "");
    if (s.video.readyState >= 1) s.duration = s.video.duration || 0;
    else s.video.addEventListener("loadedmetadata", function () { s.duration = s.video.duration || 0; });
  });

  var ambients = [].slice.call(page.querySelectorAll("video[data-autoplay]")).filter(function (v) {
    return !v.closest("[data-scrub]");
  });
  ambients.forEach(function (v) { v.muted = true; v.setAttribute("playsinline", ""); });

  var reveals = [].slice.call(page.querySelectorAll("[data-lit]"));

  function progressOf(pin) {
    var r = pin.getBoundingClientRect();
    var span = r.height - window.innerHeight;
    if (span <= 0) return 0;
    return Math.min(1, Math.max(0, -r.top / span));
  }

  function onScroll() {
    var vh = window.innerHeight;

    scrubs.forEach(function (s) {
      var p = progressOf(s.pin);
      s.target = p;
      if (s.shade) s.shade.style.opacity = String(Math.max(0, 0.92 - p * 3.4));
      if (s.heroCopy) s.heroCopy.classList.toggle("lit", p > 0.05);
      if (s.hint) s.hint.style.opacity = p > 0.72 ? "0" : "1";
      s.overlays.forEach(function (o) {
        o.el.classList.toggle("show", p >= o.from && p <= o.to);
      });
      if (s.autoplay && s.video && !reduced) {
        var pr = s.pin.getBoundingClientRect();
        var on = pr.bottom > 0 && pr.top < vh;
        if (on && s.video.paused) s.video.play().catch(function () {});
        if (!on && !s.video.paused) s.video.pause();
      }
    });

    reveals.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.88) el.classList.add("lit");
    });

    if (!reduced) {
      ambients.forEach(function (v) {
        var r = v.getBoundingClientRect();
        var on = r.bottom > 0 && r.top < vh;
        if (on && v.paused) v.play().catch(function () {});
        if (!on && !v.paused) v.pause();
      });
    }
  }

  function tick() {
    scrubs.forEach(function (s) {
      if (!s.video || !s.duration || reduced || s.autoplay) return;
      s.current += (s.target - s.current) * 0.14;
      var t = s.current * s.duration;
      if (Math.abs((s.video.currentTime || 0) - t) > 0.01) {
        try { s.video.currentTime = t; } catch (e) {}
      }
    });
    requestAnimationFrame(tick);
  }

  /* iOS/mobile: videos that are only seeked (never played) may not load or
     paint frames until a user gesture. Prime them all on first interaction. */
  var primed = false;
  function primeVideos() {
    if (primed) return;
    primed = true;
    [].slice.call(page.querySelectorAll("video")).forEach(function (v) {
      v.muted = true;
      var isLoop = v.hasAttribute("loop") || v.hasAttribute("data-autoplay");
      var p = v.play();
      if (p && p.then) {
        p.then(function () { if (!isLoop) v.pause(); }).catch(function () {});
      } else if (!isLoop) { v.pause(); }
    });
    onScroll();
  }
  window.addEventListener("touchstart", primeVideos, { once: true, passive: true });
  window.addEventListener("scroll", primeVideos, { once: true, passive: true });

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  onScroll();
  if (!reduced) requestAnimationFrame(tick);
})();
